import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext/AuthContext";
import { PrimeReactProvider } from "primereact/api";

const root = ReactDOM.createRoot(document.getElementById("root"));

const stored = localStorage.getItem("userData");
const initialUser = stored ? JSON.parse(stored) : null;

root.render(
  <React.StrictMode>
    <PrimeReactProvider value={{ unstyled: false, ripple: true }}>
      <AuthProvider initialUser={initialUser}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </PrimeReactProvider>
  </React.StrictMode>

  // <React.StrictMode>
  //   <BrowserRouter>
  //     <App />
  //   </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
